export const protocol = state => state.protocol // 保存的protocol
